import { Separator as ResizableSeparator } from 'react-resizable-panels'

export function VResizeHandle() {
  return (
    <ResizableSeparator
      className="group relative w-1.5 shrink-0 cursor-col-resize bg-slate-200 transition-colors hover:bg-blue-300 data-[separator-active=true]:bg-blue-500"
      style={{ touchAction: 'none' }}
    >
      <span className="pointer-events-none absolute inset-y-0 left-1/2 flex -translate-x-1/2 items-center text-slate-400 opacity-0 transition-opacity group-hover:opacity-100">
        <span className="block h-8 w-[3px] rounded-full bg-current" />
      </span>
    </ResizableSeparator>
  )
}

export function HResizeHandle() {
  return (
    <ResizableSeparator
      className="group relative h-1.5 shrink-0 cursor-row-resize bg-slate-200 transition-colors hover:bg-blue-300 data-[separator-active=true]:bg-blue-500"
      style={{ touchAction: 'none' }}
    >
      <span className="pointer-events-none absolute inset-x-0 top-1/2 flex -translate-y-1/2 justify-center text-slate-400 opacity-0 transition-opacity group-hover:opacity-100">
        <span className="block h-[3px] w-8 rounded-full bg-current" />
      </span>
    </ResizableSeparator>
  )
}
